var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiacritic = function SvgDiacritic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 24.4h28.8v4.8H1.6zM14.8 4 8.2 20.8h2.6l1.4-3.6h7.6l1.4 3.6H24L17.2 4zm-1.6 10.8L16 7.2l2.8 7.6z"
  })));
};
export default SvgDiacritic;